// Pins the menu/logo row to sit right below the announcement bar once
// stuck. The announcement bar itself doesn't need this: it's sticky
// directly via its own class (see .announcement-bar in
// header-announcements.liquid) since it has no other `position` value
// competing for it.
//
// The row is different: #header-component (the row's own element) also
// needs `position: absolute` conditionally, for the transparent-header
// mode — so `position: sticky` has to go on its *wrapper* instead, one
// level up. That wrapper is auto-generated by Shopify, so we find it via
// closest() (not a `:has()` CSS selector, for wider browser support) using
// `.shopify-section-group-header-group` — the class Shopify puts on every
// section wrapper in this group automatically, regardless of that
// section's own schema.
(function () {
  const headerComponent = document.querySelector('#header-component');
  const headerWrapper = headerComponent && headerComponent.closest('.shopify-section-group-header-group');
  if (headerWrapper) {
    headerWrapper.classList.add('pu-sticky-header-row');
  }
})();
